// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap
import "../stylesheets/application"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

function handleBackNavigationReload() {
  // Reload page if coming from bfcache
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  });

  // Reload page if navigating with back/forward button in browsers that don't support bfcache
  window.addEventListener("popstate", (event) => {
    // Only reload if the history state exists (prevents reload on first load)
    if (history.state) {
      window.location.reload();
    }
  });
}
handleBackNavigationReload();




